const API = "https://api.opsptm.com/api/v1";
// const API = " https://ptm.vibot.com.tw/api/v1";
export async function fetchNews({
  platform = 5, // 預設平台
  page = "", // 預設頁碼為 1
  type = "",
  tagId = "",
  size = 5,
} = {}) {
  const res = await fetch(
    `${API}/commons/announcements?type=2&platform_type=${platform}&page[number]=${page}&page[size]=${size}&activity_type=${type}&tag_id=${tagId}`
  );
  // console.log(res);
  if (!res.ok) throw new Error("Failed to fetch");
  const data = await res.json();
  // console.log("API Response:", data, "size:", size);
  return data;
}

export async function fetchEachNews(ID) {
  const res = await fetch(`${API}/commons/announcements/${ID}`);
  if (!res.ok) throw new Error("Failed to fetch");
  const data = await res.json();
  // console.log("API Response:", data); // 用於偵錯
  return data;
}

export async function fetchAllTags() {
  const res = await fetch(`${API}/commons/options/tags`);
  if (!res.ok) throw new Error("Failed to fetch allTags");
  const data = await res.json();
  // console.log("API Tags:", data);
  return data;
}

export async function fetchBulletin({ target = "1,2" } = {}) {
  const res = await fetch(
    `${API}/commons/bulletins/latest?filter[target_audience]=${target}`
  );
  // const res = await fetch(
  //   `/api/commons/bulletins/latest?filter[target_audience]=1,2`
  // );
  if (!res.ok) throw new Error("Failed to fetch bulletin");
  const data = await res.json();
  // console.log("API Bulletin:", data.data);
  return data;
}
